// extracted by mini-css-extract-plugin
module.exports = {"cardLink":"mobileStyles_cardLink__wMh8T","listingCardLink":"mobileStyles_listingCardLink__r_jA3"};